import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-10 p-lg-15" }
const _hoisted_3 = {
  class: "accordion accordion-flush accordion-icon-toggle",
  id: "kt_accordion_2"
}
const _hoisted_4 = { class: "mb-5" }
const _hoisted_5 = {
  class: "accordion-header py-3 d-flex",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_2_item_8"
}
const _hoisted_6 = { class: "accordion-icon" }
const _hoisted_7 = { class: "svg-icon svg-icon-3" }
const _hoisted_8 = { class: "fs-4 text-gray-800 fw-bold mb-0 ms-4" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div id=\"kt_accordion_2_item_8\" class=\"fs-6 collapse show ps-10\" data-bs-parent=\"#kt_accordion_2\"><h3 class=\"fs-6 fw-bolder mb-1\">New:</h3><ul class=\"py-2\"><li class=\"py-2\"> Added general modal pages <a href=\"https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/pages/profile/activity\">Preview</a></li></ul><h3 class=\"fs-6 fw-bolder mb-1\">Fixes:</h3><ul class=\"py-2\"><li class=\"py-2\"> Fixed DrawerMessanger initialization bug <a href=\"https://preview.keenthemes.com/metronic8/vue/demo1/#/apps/chat/drawer-chat\">Preview</a></li></ul></div>", 1)
const _hoisted_10 = { class: "mb-5" }
const _hoisted_11 = {
  class: "accordion-header py-3 d-flex collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_2_item_7"
}
const _hoisted_12 = { class: "accordion-icon" }
const _hoisted_13 = { class: "svg-icon svg-icon-3" }
const _hoisted_14 = { class: "fs-4 text-gray-800 fw-bold mb-0 ms-4" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div id=\"kt_accordion_2_item_7\" class=\"fs-6 collapse ps-10\" data-bs-parent=\"#kt_accordion_2\"><h3 class=\"fs-6 fw-bolder mb-1\">New:</h3><ul class=\"py-2\"><li class=\"py-2\"> Added general modal pages <ul class=\"py-2\"><li class=\"py-2\"> Invite Friends <a href=\"https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/modals/general/invite-friends\">Preview</a></li><li class=\"py-2\"> View Users <a href=\"https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/modals/general/view-user\">Preview</a></li><li class=\"py-2\"> Upgrade Plan <a href=\"https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/modals/general/upgrade-plan\">Preview</a></li><li class=\"py-2\"> Share &amp; Earn <a href=\"https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/modals/general/share-and-earn\">Preview</a></li></ul></li><li class=\"py-2\"> Added form modal pages <ul class=\"py-2\"><li class=\"py-2\"> New Targer <a href=\"https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/modals/forms/new-target\">Preview</a></li><li class=\"py-2\"> New Card <a href=\"https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/modals/forms/new-card\">Preview</a></li><li class=\"py-2\"> New Address <a href=\"https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/modals/forms/new-address\">Preview</a></li><li class=\"py-2\"> Create API Key <a href=\"https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/modals/forms/create-api-key\">Preview</a></li></ul></li><li class=\"py-2\"> Added wizard modal pages <ul class=\"py-2\"><li class=\"py-2\"> Two Factor Auth <a href=\"https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/modals/wizards/two-factor-auth\">Preview</a></li><li class=\"py-2\"> Create App <a href=\"https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/modals/wizards/create-app\">Preview</a></li><li class=\"py-2\"> Create Account <a href=\"https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/modals/wizards/create-account\">Preview</a></li></ul></li></ul></div>", 1)
const _hoisted_16 = { class: "mb-5" }
const _hoisted_17 = {
  class: "accordion-header py-3 d-flex collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_2_item_6"
}
const _hoisted_18 = { class: "accordion-icon" }
const _hoisted_19 = { class: "svg-icon svg-icon-3" }
const _hoisted_20 = { class: "fs-4 text-gray-800 fw-bold mb-0 ms-4" }
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div id=\"kt_accordion_2_item_6\" class=\"fs-6 collapse ps-10\" data-bs-parent=\"#kt_accordion_2\"><h3 class=\"fs-6 fw-bolder mb-1\">New:</h3><ul class=\"py-2\"><li class=\"py-2\"> Added widgets pages <a href=\"https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/widgets/lists\">Preview</a></li></ul></div>", 1)
const _hoisted_22 = { class: "mb-5" }
const _hoisted_23 = {
  class: "accordion-header py-3 d-flex collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_2_item_5"
}
const _hoisted_24 = { class: "accordion-icon" }
const _hoisted_25 = { class: "svg-icon svg-icon-3" }
const _hoisted_26 = { class: "fs-4 text-gray-800 fw-bold mb-0 ms-4" }
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<div id=\"kt_accordion_2_item_5\" class=\"fs-6 collapse ps-10\" data-bs-parent=\"#kt_accordion_2\"><h3 class=\"fs-6 fw-bolder mb-1\">New:</h3><ul class=\"py-2\"><li class=\"py-2\"> Added vue-i18n plugin and menu translation example. Update languge in profile dropdown. <a href=\"https://preview.keenthemes.com/metronic8/vue/demo1/#/dashboard\">Preview</a></li></ul></div>", 1)
const _hoisted_28 = { class: "mb-5" }
const _hoisted_29 = {
  class: "accordion-header py-3 d-flex collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_2_item_4"
}
const _hoisted_30 = { class: "accordion-icon" }
const _hoisted_31 = { class: "svg-icon svg-icon-3" }
const _hoisted_32 = { class: "fs-4 text-gray-800 fw-bold mb-0 ms-4" }
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<div id=\"kt_accordion_2_item_4\" class=\"fs-6 collapse ps-10\" data-bs-parent=\"#kt_accordion_2\"><h3 class=\"fs-6 fw-bolder mb-1\">New:</h3><ul class=\"py-2\"><li class=\"py-2\"> Added private chat page. <a href=\"https://preview.keenthemes.com/metronic8/vue/demo1/#/apps/chat/private-chat\">Preview</a></li><li class=\"py-2\"> Added group chat page. <a href=\"https://preview.keenthemes.com/metronic8/vue/demo1/#/apps/chat/group-chat\">Preview</a></li><li class=\"py-2\"> Added drawer chat page. <a href=\"https://preview.keenthemes.com/metronic8/vue/demo1/#/apps/chat/drawer-chat\">Preview</a></li></ul></div>", 1)
const _hoisted_34 = { class: "mb-5" }
const _hoisted_35 = {
  class: "accordion-header py-3 d-flex collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_2_item_3"
}
const _hoisted_36 = { class: "accordion-icon" }
const _hoisted_37 = { class: "svg-icon svg-icon-3" }
const _hoisted_38 = { class: "fs-4 text-gray-800 fw-bold mb-0 ms-4" }
const _hoisted_39 = /*#__PURE__*/_createStaticVNode("<div id=\"kt_accordion_2_item_3\" class=\"fs-6 collapse ps-10\" data-bs-parent=\"#kt_accordion_2\"><h3 class=\"fs-6 fw-bolder mb-1\">New:</h3><ul class=\"py-2\"><li class=\"py-2\"> Added wizard demo pages. <a href=\"https://preview.keenthemes.com/metronic8/vue/demo1/#/crafted/pages/wizards/vertical\">Preview</a></li></ul></div>", 1)
const _hoisted_40 = { class: "mb-5" }
const _hoisted_41 = {
  class: "accordion-header py-3 d-flex collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_2_item_2"
}
const _hoisted_42 = { class: "accordion-icon" }
const _hoisted_43 = { class: "svg-icon svg-icon-3" }
const _hoisted_44 = { class: "fs-4 text-gray-800 fw-bold mb-0 ms-4" }
const _hoisted_45 = /*#__PURE__*/_createStaticVNode("<div id=\"kt_accordion_2_item_2\" class=\"fs-6 collapse ps-10\" data-bs-parent=\"#kt_accordion_2\"><h3 class=\"fs-6 fw-bolder mb-1\">New:</h3><ul class=\"py-2\"><li class=\"py-2\"> Setup theme skeleton doc. <a href=\"https://preview.keenthemes.com/metronic8/vue/demo1/#/documentation/setup-theme-skeleton\">Preview</a></li></ul><h3 class=\"fs-6 fw-bolder mb-1\">Update:</h3><ul class=\"py-2\"><li class=\"py-2\"> Updated sign-in form buttons. <a href=\"https://preview.keenthemes.com/metronic8/vue/demo1/#/sign-in\">Preview</a></li></ul></div>", 1)
const _hoisted_46 = { class: "mb-5" }
const _hoisted_47 = {
  class: "accordion-header py-3 d-flex collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_2_item_1"
}
const _hoisted_48 = { class: "accordion-icon" }
const _hoisted_49 = { class: "svg-icon svg-icon-3" }
const _hoisted_50 = { class: "fs-4 text-gray-800 fw-bold mb-0 ms-4" }
const _hoisted_51 = /*#__PURE__*/_createVNode("div", {
  id: "kt_accordion_2_item_1",
  class: "fs-6 collapse ps-10",
  "data-bs-parent": "#kt_accordion_2"
}, [
  /*#__PURE__*/_createVNode("ul", { class: "py-2" }, [
    /*#__PURE__*/_createVNode("li", { class: "py-2" }, "Initial release.")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("span", _hoisted_6, [
              _createVNode("span", _hoisted_7, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Right-2.svg" })
              ])
            ]),
            _createVNode("h3", _hoisted_8, _toDisplayString(_ctx.themeName) + " v8.0.17 - 7 July, 2021 ", 1)
          ]),
          _hoisted_9
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode("span", _hoisted_12, [
              _createVNode("span", _hoisted_13, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Right-2.svg" })
              ])
            ]),
            _createVNode("h3", _hoisted_14, _toDisplayString(_ctx.themeName) + " v8.0.16 - 28 June, 2021 ", 1)
          ]),
          _hoisted_15
        ]),
        _createVNode("div", _hoisted_16, [
          _createVNode("div", _hoisted_17, [
            _createVNode("span", _hoisted_18, [
              _createVNode("span", _hoisted_19, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Right-2.svg" })
              ])
            ]),
            _createVNode("h3", _hoisted_20, _toDisplayString(_ctx.themeName) + " v8.0.15 - 17 June, 2021 ", 1)
          ]),
          _hoisted_21
        ]),
        _createVNode("div", _hoisted_22, [
          _createVNode("div", _hoisted_23, [
            _createVNode("span", _hoisted_24, [
              _createVNode("span", _hoisted_25, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Right-2.svg" })
              ])
            ]),
            _createVNode("h3", _hoisted_26, _toDisplayString(_ctx.themeName) + " v8.0.14 - 4 June, 2021 ", 1)
          ]),
          _hoisted_27
        ]),
        _createVNode("div", _hoisted_28, [
          _createVNode("div", _hoisted_29, [
            _createVNode("span", _hoisted_30, [
              _createVNode("span", _hoisted_31, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Right-2.svg" })
              ])
            ]),
            _createVNode("h3", _hoisted_32, _toDisplayString(_ctx.themeName) + " v8.0.13 - 9 June, 2021 ", 1)
          ]),
          _hoisted_33
        ]),
        _createVNode("div", _hoisted_34, [
          _createVNode("div", _hoisted_35, [
            _createVNode("span", _hoisted_36, [
              _createVNode("span", _hoisted_37, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Right-2.svg" })
              ])
            ]),
            _createVNode("h3", _hoisted_38, _toDisplayString(_ctx.themeName) + " v8.0.12 - 28 May, 2021 ", 1)
          ]),
          _hoisted_39
        ]),
        _createVNode("div", _hoisted_40, [
          _createVNode("div", _hoisted_41, [
            _createVNode("span", _hoisted_42, [
              _createVNode("span", _hoisted_43, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Right-2.svg" })
              ])
            ]),
            _createVNode("h3", _hoisted_44, _toDisplayString(_ctx.themeName) + " v8.0.11 - 26 May, 2021 ", 1)
          ]),
          _hoisted_45
        ]),
        _createVNode("div", _hoisted_46, [
          _createVNode("div", _hoisted_47, [
            _createVNode("span", _hoisted_48, [
              _createVNode("span", _hoisted_49, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Right-2.svg" })
              ])
            ]),
            _createVNode("h3", _hoisted_50, _toDisplayString(_ctx.themeName) + " v8.0.10 - 21 May, 2021 ", 1)
          ]),
          _hoisted_51
        ])
      ])
    ])
  ]))
}